import type { FunctionComponent } from 'react';
import * as styles from './BreakLine.module.scss';

const BreakLine: FunctionComponent = () => (
  <div data-testid="break-line" className={styles.breakLine} />
);

export default BreakLine;
